import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardHeader, CardContent, Avatar, IconButton, Typography, Grid, Button } from "@material-ui/core";
import moment from "moment";
import CloseIcon from "@material-ui/icons/Close";
import API from "../../actions";

const useStyles = makeStyles(theme => ({
    root: {
        width: "100%",
        height: "100%",
        position: "inherit",
        zIndex: 2,
        display: "flex",
        flexDirection: "column"
    }
}));

export default props => {
    const classes = useStyles();
    const [clients, setClients] = React.useState([]);
    const [waitingClients, setWaitingClients] = React.useState([]);

    const getClients = async id => {
        const c = await API.getEventDateClientsFromTherapist();

        const cMap = [];
        const cMapWaiting = [];

        await Promise.all(
            c.map(async client => {
                if (client.eventDateId === id) {
                    const t = await API.getClient(client.clientId);
                    client.email = t.email;
                    if (client.isWaiting === true) {
                        cMapWaiting.push(client);
                    } else {
                        cMap.push(client);
                    }
                }
            })
        );
        setClients(cMap);
        setWaitingClients(cMapWaiting);
    };

    useEffect(() => {
        getClients(props.event.id);
    }, [props.event.id]);

    const handleDeleteClient = async eventDateClientId => {
        if (!window.confirm("Er du sikker?")) return;
        await API.deleteEventDateClient(eventDateClientId).then(
            success => {
                getClients(props.event.id);
            },
            err => {}
        );
    };

    return (
        <Card className={classes.root}>
            <CardHeader
                avatar={
                    <Avatar aria-label="recipe" style={{ backgroundColor: props.event.backgroundColor }}>
                        K
                    </Avatar>
                }
                action={
                    <IconButton aria-label="settings" onClick={() => props.close()}>
                        <CloseIcon />
                    </IconButton>
                }
                title={props.event.orgTitle}
                subheader={moment(props.event.start).format("DD/MM/YYYY, HH:mm:ss") + " -" + props.event.dkTime}
            />
            <CardContent style={{ flex: 1 }}>
                <Grid
                    container
                    spacing={0}
                    style={{
                        padding: "5px 10px 10px 10px",
                        borderRadius: "5px"
                    }}>
                    <Grid item sm={6} style={{ width: "100%", paddingTop: "7.5px" }}>
                        <Typography variant="body1" color="textSecondary" component="p">
                            Beskrivelse
                        </Typography>
                        <Typography
                            className={classes.desc}
                            dangerouslySetInnerHTML={{ __html: props.event.desc }}></Typography>{" "}
                    </Grid>
                    <Grid item sm={6} style={{ width: "100%", paddingTop: "7.5px" }}>
                        <Grid
                            container
                            spacing={0}
                            style={{
                                borderRadius: "5px"
                            }}>
                            <Grid item sm={1} style={{ width: "100%" }}>
                                <Typography variant="body1" color="textSecondary" component="p">
                                    &nbsp;
                                </Typography>
                            </Grid>
                            <Grid item sm={11} style={{ width: "100%" }}>
                                <Typography variant="body1" color="textSecondary" component="p">
                                    Klienter
                                </Typography>
                            </Grid>
                        </Grid>
                        {clients.map((c, index) => {
                            return (
                                <Grid
                                    container
                                    spacing={0}
                                    style={{
                                        padding: "5px 10px 10px 0px",
                                        borderRadius: "5px"
                                    }}>
                                    <Grid item sm={1} style={{ width: "100%", paddingTop: "5px" }}>
                                        <Typography variant="body1" color="textPrimary" component="p">
                                            {index + 1}
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={9} style={{ width: "100%", paddingTop: "5px" }}>
                                        <Typography variant="body1" color="textPrimary" component="p">
                                            {c.nameFirst} {c.nameLast}
                                        </Typography>
                                        <Typography variant="body1" color="textPrimary" component="p">
                                            {c.email}
                                        </Typography>
                                    </Grid>
                                    <Grid
                                        item
                                        sm={2}
                                        style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <Button onClick={() => handleDeleteClient(c.id)} color="secondary">
                                            Slet
                                        </Button>
                                    </Grid>
                                </Grid>
                            );
                        })}
                        {waitingClients.length > 0 ? (
                            <Grid
                                container
                                spacing={0}
                                style={{
                                    borderRadius: "0px",
                                    borderTop: "2px solid #babac0",
                                    paddingTop: "5px"
                                }}>
                                <Grid item sm={1} style={{ width: "100%" }}>
                                    <Typography variant="body1" color="textSecondary" component="p">
                                        &nbsp;
                                    </Typography>
                                </Grid>
                                <Grid item sm={11} style={{ width: "100%" }}>
                                    <Typography variant="body1" color="textSecondary" component="p">
                                        Venteliste
                                    </Typography>
                                </Grid>
                            </Grid>
                        ) : (
                            <></>
                        )}
                        {waitingClients.map((c, index) => {
                            return (
                                <Grid
                                    container
                                    spacing={0}
                                    style={{
                                        padding: "5px 10px 10px 0px",
                                        borderRadius: "5px"
                                    }}>
                                    <Grid item sm={1} style={{ width: "100%", paddingTop: "5px" }}>
                                        <Typography variant="body1" color="textPrimary" component="p">
                                            {index + 1}
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={11} style={{ width: "100%", paddingTop: "5px" }}>
                                        <Typography variant="body1" color="textPrimary" component="p">
                                            {c.nameFirst} {c.nameLast}
                                        </Typography>
                                        <Typography variant="body1" color="textPrimary" component="p">
                                            {c.email}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            );
                        })}
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};
